import { FC, useState } from "react";
import { CampaignType } from "@vviinn/user-managment-client-ts";

import { NewCampaignForm } from "../../campaign/new/NewCampaignForm";
import { unfulfilledConditionPage } from "../../components/GeneralUI/Message/unfulfilledConditionPage";
import { useCampaignDefaults } from "../../campaign/hooks/useCampaignDefaults";

export const CampaignNew: FC = () => {
  const [campaignType, setCampaignType] = useState<CampaignType | "BOOSTING">();
  const serviceCampaignType =
    campaignType !== "BOOSTING" ? campaignType : undefined;
  const { allowedServices, defaultPresetValues, relevantNets } =
    useCampaignDefaults(serviceCampaignType);

  return allowedServices?.length ? (
    <NewCampaignForm
      campaignType={campaignType}
      setCampaignType={setCampaignType}
      defaultPresetValues={defaultPresetValues}
      relevantNets={relevantNets}
    />
  ) : (
    unfulfilledConditionPage(
      "activate a plan with at least one service",
      "a new campaign",
    )
  );
};
